import './Services.css';

function SrvMOTORTESTER() {
    const hanessItems = [
      { title: '검사 방식', value: '파우더 브레이크를 이용한 부하검사' },
      { title: '검사 모드', value: '연속운전 / 정역운전(시간) / 정역운전(리미트)' },
      { title: '결과 출력', value: '터치스크린 / USB' },
      { title: '통신', value: 'RS-485 Modbus RTU' },
      { title: '공급전원', value: '100-240Vac 50/60Hz' }
    ];

    return (
      <div className="overview-container">
        <div className="section-title-box">모터 신뢰성 검사기 DC/BLDC Motor Tester</div>
        <div className="services-header">
          <div className="services-image">
            <img src="/images/motortester1.jpg" alt="MOTOR TESTER외형" />
            <img src="/images/motortester3.bmp" alt="MOTOR TESTER터치1" />
            <img src="/images/motortester4.png" alt="MOTOR TESTER EXCEL" />
          </div>
          <div className="services-text">
            <p>
            <strong>DC/BLDC MOTOR 신뢰성 검사장비입니다.</strong>
            </p>
            <p>  
            사용부하기준 정격상태에서 모터의 사용횟수(시간)을 측정하는 시험기입니다.<br></br>
            - 반복시험을 시행하여 기어파손 및 코일소손을 검사합니다.<br></br>
            - DC/BLDC/STEPPING MOTOR등 광범위한 모터를 검사할 수 있습니다.<br></br>
            - 시험데이터는 Excel파일로 관리할 수 있습니다.<br></br>
            - 모터 전압공급 불량 알람기능 <br></br>
            - 모터 구동전류 상/하한 불량 알람기능 <br></br>
            - 정역회전별 구동전압, 구동전류, 브레이크전압, 브레이크전류 Data Logger <br></br>
            </p>
          </div>
        </div>

        <div className="overview-table">
            {hanessItems.map((item, index) => (
            <div key={index} className="overview-row">
                <div className="overview-title">{item.title}</div>
                <div className="overview-value">{item.value}</div>
            </div>
            ))}
        </div>
      </div>
    );
}

export default SrvMOTORTESTER;
